import { render } from "./TotalMensalCobrancaView.vue?vue&type=template&id=30cc2636&scoped=true"
import script from "./TotalMensalCobrancaView.vue?vue&type=script&lang=js"
export * from "./TotalMensalCobrancaView.vue?vue&type=script&lang=js"

import "./TotalMensalCobrancaView.vue?vue&type=style&index=0&id=30cc2636&scoped=true&lang=css"

import exportComponent from "C:\\GarantePay\\Desenvolvimento2026\\CodigoVue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30cc2636"]])

export default __exports__